<template>
  <div class="left-container">
    <div :class="isHome ? 'fold-containers' : 'fold-container'">
      <i class="el-icon-arrow-left" @click="handlerFold" v-if="!isHome"></i>
      <i class="el-icon-arrow-right" @click="handlerFold" v-if="isHome && clickIndex !== 6 && clickIndex !== 5"></i>
    </div>
    <div class="alarm-containers">
      <img class="alarm-icon" src="@/assets/alarm.png" alt="" v-if="count === 0"/>
      <img class="alarm-icon1" src="@/assets/alarm.webp" alt="" @click="showAlarm" v-else/>
      <!-- <img class="alarm-icon1" src="@/assets/alarm.webp" alt="" @click="showAlarm"/> -->
      <!-- <div class="red-dot" v-if="count > 0">{{ count }}</div> -->
      <el-button icon="el-icon-arrow-down" circle size="mini" @click="isShowAlarm = !isShowAlarm"  v-if="isShowAlarm"></el-button>
      <el-button icon="el-icon-arrow-up" circle size="mini" @click="isShowAlarm = !isShowAlarm" v-if="!isShowAlarm && count > 0"></el-button>
      <div class="right-alarm-list" v-if="isShowAlarm">
        <el-collapse-transition>
        <seamless-scroll :data="alarmList" :class-option="scrollClass" :loop="true">
        <div v-for="(item, index) in alarmList" :key="index" class="item-contents">
          <div class="item-ebike">
            <div class="item-ebike-id">{{ item.ebikeId }}</div>
            <div class="item-ebike-text">{{ $t('home.name38') }}</div>
          </div>
        </div>
      </seamless-scroll>
      </el-collapse-transition>
      </div>
    </div>
    <div class="top-layout">
      <img class="top-icon" src="@/assets/mylogo.png" alt="" />
      <div class="title">
        {{ $t('public.name8') }}
        <span v-if="userinfo.tenantType === 0">- {{ $t('home.name51') }}</span>
        <span v-if="userinfo.tenantType === 1">- {{ $t('home.name52') }}</span>
        <span v-if="userinfo.tenantType === 20">- {{ $t('home.name53') }}</span>
        <span v-if="userinfo.tenantType === 21">- {{ $t('home.name54') }}</span>
        <span v-if="userinfo.tenantType === 22">- {{ $t('home.name55') }}</span>
        <span v-if="userinfo.tenantType === 30">- {{ $t('home.name56') }}</span>
        <span v-if="userinfo.tenantType === 31">- {{ $t('home.name57') }}</span>
        <span v-if="userinfo.tenantType === 32">- {{ $t('home.name58') }}</span>
      </div>
      <!-- <el-tabs v-model="activeTab" v-if="userinfo.tenantType === 1" @tab-click="changeTab">
      <el-tab-pane label="厂商" name="one"></el-tab-pane>
      <el-tab-pane label="共享版" name="two"></el-tab-pane>
      <el-tab-pane label="租赁版" name="three"></el-tab-pane>
      <el-tab-pane label="售车版" name="four"></el-tab-pane>
    </el-tabs> -->
    </div>
    <el-container>
      <el-aside width="">
        <el-scrollbar ref="scrollMenuRef" :class="isHome ? 'vab-column-bar-containers' : 'vab-column-bar-container'">
          <div>
            <el-tabs tab-position="left" v-model="activeName">
            <el-tab-pane v-for="(item, index) in menulist" :key="index" :name="item.component">
              <el-tooltip
                slot="label"
                :disabled="lang === 'zh'"
                :content="item.emenuName"
                placement="right"
                :open-delay="400"
                effect="dark"
                class="nav-rail-tooltip"
              >
                <div
                  :class="index === clickIndex ? 'vab-column-grids' : 'vab-column-grid'"
                  @click="clickTab(item, index)"
                >
                  <img class="ico-navbar" :src="item.icon" alt="" />
                  <span class="nav-rail-label">{{ lang === 'zh' ? item.menuName : item.emenuName }}</span>
                </div>
              </el-tooltip>
            </el-tab-pane>
          </el-tabs>
          <div class="left-bottom-layout">
            <div class="bell" @click="goSystemNotification" v-if="isShowNotice">
              <i class="el-icon-bell"></i>
              <!-- <div>20</div> -->
            </div>
            <i class="el-icon-setting" @click="goSetting"></i>
            <img v-if="lang === 'zh'" class="icon-language"  src="@/assets/language.png" alt=""  @click="changeLanguage"/>
            <img v-else class="icon-language"  src="@/assets/languages.png" alt=""  @click="changeLanguage"/>
            <div class="user-head">
              <div class="el-dropdown">
                <el-popover placement="top" trigger="hover" v-model="visiblehover">
                  <!-- <li @click="logout" class="el-dropdown-menu__item">
                    <span>{{ $t('public.name7') }}</span>
                  </li> -->
                  <div>
                    <div class="zhxx">
                      <div>{{ $t('home.name31') }}</div>
                      <div class="tcdl">
                        <div class="margin-right20" @click="showChangePw">{{ $t('home.name32') }}</div>
                        <div @click="logout" >{{ $t('public.name7') }}</div>
                      </div>
                    </div>
                    <div class="item-style">{{ $t('home.name71') }}<span>{{ displayLoginName }}</span></div>
                    <div class="item-style">{{ $t('manage.name25') }}<span>{{ userinfo.roleName }}</span></div>
                    <div class="item-style">{{ $t('home.name33') }}<span>{{ userinfo.tenantName }}</span></div>
                    <div class="item-style">{{ $t('home.name34') }}<span>{{ userinfo.loginDate }}</span></div>
                    <div class="item-style">{{ $t('home.name35') }}<span>{{ userinfo.loginIp }}</span></div>
                    <div class="item-style">{{ $t('home.name36') }}<span>{{ userinfo.lastLoginDate }}</span></div>
                  </div>
                  <span slot="reference" class="avatar-dropdown" role="button">
                    <span class="user-avatar el-avatar">
                      <img src="https://i.gtimg.cn/club/item/face/img/2/16022_100.gif" style="object-fit: cover;" />
                    </span>
                  </span>
                </el-popover>
              </div>
            </div>
          </div>
          </div>
        <el-menu :default-active="permUrl" :class="isHome ? 'el-menu-vertical-demos' : 'el-menu-vertical-demo'" :router="true" >
            <div v-for="(item, index) in menulist" :key="index">
              <template v-if="lang === 'zh' ? item.menuName === permName : item.emenuName === permName">
                <div v-for="(items, indexs) in item.childList" :key="indexs">
                  <template v-if="items.childList.length > 0">
                    <el-submenu :index="'/' + items.component">
                      <template slot="title">
                        <el-tooltip
                          :disabled="lang === 'zh'"
                          :content="sidebarMenuTooltip(items)"
                          placement="right"
                          :open-delay="400"
                          effect="dark"
                        >
                          <span class="sidebar-menu-label">{{ sidebarMenuText(items) }}</span>
                        </el-tooltip>
                      </template>
                      <template v-if="items.childList">
                        <el-menu-item :index="'/' + sybItem.component" v-for="(sybItem, indexkey) in items.childList" :key="indexkey">
                          <el-tooltip
                            :disabled="lang === 'zh'"
                            :content="sidebarMenuTooltip(sybItem)"
                            placement="right"
                            :open-delay="400"
                            effect="dark"
                          >
                            <span class="sidebar-menu-label sidebar-menu-label--nested">{{ sidebarMenuText(sybItem) }}</span>
                          </el-tooltip>
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                  <template v-else>
                    <el-menu-item :index="'/' + items.component">
                      <el-tooltip
                        :disabled="lang === 'zh'"
                        :content="sidebarMenuTooltip(items)"
                        placement="right"
                        :open-delay="400"
                        effect="dark"
                      >
                        <span class="sidebar-menu-label">{{ sidebarMenuText(items) }}</span>
                      </el-tooltip>
                    </el-menu-item>
                  </template>
                </div>
              </template>
            </div>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-container :class="isHome ? 'right-containers' : 'right-container'">
        <el-header class="fixed-header" :class="isHome ? 'vab-layout-headers' : 'vab-layout-header'">
          <el-tag
          v-for="(tag,index) in tagList"
          :key="index"
          :type="tag.type"
          :disable-transitions="false"
          @close="handleCloseTag(tag)"
          @click="handleClickTag(tag)"
          :closable="tagList.length > 1 ? true: false">
          {{ lang === 'zh' ?  tag.name : tag.ename }}
        </el-tag>
        </el-header>
        <el-main class="right-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible"  :fullscreen="true"  :modal="false" :show-close="false" :title="$t('bike.name82')" class="detalis-content">
      <div>
        <img  v-if="activeTab === 'two'"   src="@/assets/screenshot1.png"/>
        <img  v-if="activeTab === 'four'"   src="@/assets/screenshot2.png"/>
      </div>
    </el-dialog>
    <el-dialog
  custom-class="change-pw-dialog"
  :title="$t('home.name32')"
  :visible.sync="passwordDialogVisible"
  v-if="passwordDialogVisible"
  width="36%"
  :before-close="handleClose">
  <el-form ref="changePwFormRef" class="change-pw-form" :model="changePwForm" :rules="pwFormRules" :label-width="formLabelWidth('xl')">
    <el-form-item prop="oldPwd" :label="$t('home.name37')">
            <el-input v-model="changePwForm.oldPwd" :placeholder="$t('public.name5')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
          </el-form-item>

          <el-form-item prop="newPwd" :label="$t('operate.name164')">
            <el-input v-model="changePwForm.newPwd" :placeholder="$t('public.name5')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
          </el-form-item>

          <el-form-item prop="againPwd" :label="$t('operate.name165')">
            <el-input v-model="changePwForm.againPwd" :placeholder="$t('public.name5')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"> </el-input>
          </el-form-item>
        </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">{{ $t('public.name14') }}</el-button>
    <el-button type="primary" @click="sumbitPw">{{ $t('public.name25') }}</el-button>
  </span>
</el-dialog>

<el-dialog
custom-class="alarm-dialog el-dialog--responsive"
  :title="$t('home.name59')"
  :visible.sync="alarmDialogVisible"
  v-if="alarmDialogVisible"
  append-to-body
  width="80%"
  :before-close="handleAlarmClose">
  <RealTimeAlarm :alarm-list="alarmList"></RealTimeAlarm>
</el-dialog>
  </div>
</template>
<script>
import { getTabmenuKeyByComponent } from '@/utils/sidebarMenuLabel'
import { getStoredLocale } from '@/config/flavor'
import Cookies from 'js-cookie'
import { getMenus } from '@/api/user.js'
import { mapGetters } from 'vuex'
import { functionpageclick, findLatestBcstMsgCount, findLatestBcstMsgList } from '@/api/home.js'
import { innerUpdatePwd } from '@/api/manage.js'
import { validatePass } from '@/utils/utils.js'
import RealTimeAlarm from '@/components/RealTimeAlarm'
import SeamlessScroll from 'vue-seamless-scroll'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    displayLoginName () {
      const loginName = this.userinfo && this.userinfo.loginName
      if (!loginName) return ''
      return loginName.indexOf('CN-86') > -1 ? loginName.slice(6, 17) : loginName
    },
    pwFormRules () {
      const validateRePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('retrievePassword.name14')))
        } else if (value !== this.changePwForm.newPwd) {
          callback(new Error(this.$t('retrievePassword.name15')))
        } else {
          callback()
        }
      }
      return {
        oldPwd: [
          {
            required: true,
            message: this.$t('home.name60'),
            trigger: 'blur'
          }
        ],
        newPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        againPwd: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  data() {
    return {
      scrollClass: {
        'item-contents': true,
        step: 0.5,
        direction: 1,
        limitMoveNum: 2,
        hoverStop: false,
        openWatch: true
      },
      visiblehover: false,
      isShowAlramList: false,
      dialogVisible: false,
      alarmDialogVisible: false,
      passwordDialogVisible: false,
      readonlyInput: true,
      isHome: false,
      loginName: '',
      activeName: '',
      activeTab: 'one',
      permName: '',
      clickIndex: 0,
      permUrl: '/',
      breadList: [],
      tagList: [],
      timer: null,
      isShowNotice: false,
      menulist: [],
      buttonPerms: '',
      lang: '',
      noticePermName: '',
      settingPermName: '',
      changePwForm: {
        oldPwd: '',
        newPwd: '',
        againPwd: ''
      },
      count: 0,
      alarmList: [],
      isShowAlarm: false
    }
  },
  components: {
    RealTimeAlarm,
    SeamlessScroll
  },
  created() {
    // console.log('tenantType====', this.userinfo)
    this.lang = getStoredLocale()
    if (!this.loginName) {
      this.loginName = this.$t('home.name51')
    }
  },
  watch: {
    alarmDialogVisible (visible) {
      document.body.classList.toggle('alarm-dialog-open', visible)
    },
    $route (to, from) {
      console.log('to.path===', to.path)
      // if (this.$route.name === 'Home') {
      //   this.isHome = true
      //   this.clickIndex = 0
      // }
      var isExist = false
      if (to.path === '/systemNotification') {
        this.clickIndex = 5
        this.tagList.map((item) => {
          if (item.path === '/systemNotification') {
            isExist = true
          }
        })
        if (!isExist) {
          this.tagList.push({ name: this.$t('tabmenu.name33'), ename: 'Notifications', path: '/systemNotification', index: this.clickIndex, type: 'info' })
        }
        this.isHome = true
      } else if (to.path === '/setting') {
        this.clickIndex = 6
        this.tagList.map((item) => {
          if (item.path === '/setting') {
            isExist = true
          }
        })
        if (!isExist) {
          this.tagList.push({ name: this.$t('tabmenu.name34'), ename: 'Setting', path: '/setting', index: this.clickIndex, type: 'info' })
        }
        this.isHome = true
      } else if (to.path === '/smsConfiguration') {
        this.clickIndex = 4
        this.tagList.map((item) => {
          if (item.path === '/smsConfiguration') {
            isExist = true
          }
        })
        if (!isExist) {
          this.tagList.push({ name: this.$t('bike.name533'), ename: 'SMSConfiguration', path: '/smsConfiguration', index: this.clickIndex, type: 'info' })
        }
        this.isHome = false
      } else {
        this.isHome = false
      }
      this.breadList = this.$route.matched
      this.activeName = this.breadList[1].name
      const bread = this.breadList.length === 3 ? this.breadList[2].path : this.breadList[1].path
      let permName1 = ''
      let permName2 = ''
      console.log('bread=====1', bread)
      this.menulist.map((item, indexs) => {
        if (bread === '/' + item.component) {
          if (this.lang === 'zh') {
            this.permName = item.menuName
          } else {
            this.permName = item.emenuName
          }
          permName1 = item.menuName
          permName2 = item.emenuName
        }
        item.childList.map((items) => {
          if (bread === '/' + items.component || (to.path === '/smsConfiguration' && items.component === 'manufacturerslist')) {
            permName1 = items.menuName
            permName2 = items.emenuName
            console.log('bread=====3', items)
          }
          items.childList.map((itemss) => {
            if (bread === '/' + itemss.component || (to.path === '/smsConfiguration' && itemss.component === 'manufacturerslist')) {
              permName1 = itemss.menuName
              permName2 = itemss.emenuName
              console.log('bread=====4', itemss)
            }
          })
        })
      })
      // if (this.userinfo.tenantType === 22 && to.path === '/dataScreening') {
      //   this.isHome = true
      // }
      var type = 'info'
      this.tagList.map((item) => {
        if (item.path === bread) {
          isExist = true
        }
      })
      if (!isExist) {
        this.tagList.push({ name: permName1, ename: permName2, path: bread, index: this.clickIndex, type: type })
      }
      this.tagList.map((item) => {
        if (item.path === bread) {
          item.type = ''
        } else {
          item.type = 'info'
        }
      })
      this.tagList.map((item) => {
        if (item.type === '') {
          this.clickIndex = item.index
        }
      })
      let permName = ''
      let lang = ''
      if (this.lang === 'zh') {
        permName = permName1
        lang = 'zh-CN'
      } else {
        permName = permName2
        lang = 'en-US'
      }
      functionpageclick({ pageName: permName, lang: lang })
        .then((res) => {
          if (res.code === 200) {
          }
        })
        .catch(() => {})
      localStorage.setItem('clickIndex', this.clickIndex)
      this.menulist.map((item, index) => {
        if (index === this.clickIndex) {
          if (this.lang === 'zh') {
            this.permName = item.menuName
          } else {
            this.permName = item.emenuName
          }
          localStorage.setItem('permName', this.permName)
          this.permUrl = bread
          // console.log('this.permUrl===2', this.permUrl)
        }
      })
    }
  },
  mounted() {
    this.$bus.$on('clickIndex', (path, index) => {
      this.menulist.map((item, indexs) => {
        if (indexs === index) {
          if (this.lang === 'zh') {
            this.permName = item.menuName
          } else {
            this.permName = item.emenuName
          }
          localStorage.setItem('permName', this.permName)
          this.permUrl = '/' + path
          // console.log('===3', this.permUrl)
          // console.log('===4', this.permName)
          this.$router.push('/' + path)
          this.clickIndex = index
        }
      })
    })
    // if (this.userinfo.tenantType === 22 && this.$route.path === '/dataScreening') {
    //   this.isHome = true
    // }
    this.getMenusList()
    this.timer = setInterval(this.getFindLatestBcstMsgCount, 60000)
    this.getFindLatestBcstMsgCount()
    // const dataList = [{ ebikeId: 'LS864643060096171' }, { ebikeId: 'LS864643060096172' }]
    // this.alarmList = []
    // this.alarmList = dataList
    // this.count = this.alarmList.length
    // this.isShowAlarm = true
  },
  beforeDestroy() {
    this.$bus.$off('clickIndex')
    clearInterval(this.timer)
    this.timer = null
    document.body.classList.remove('alarm-dialog-open')
  },
  methods: {
    getFindLatestBcstMsgCount() {
      const data = {
        startTime: '',
        endTime: ''
      }
      findLatestBcstMsgCount(data).then((res) => {
        if (res.code === 200) {
          if (res.data.count > 0) {
            this.getFindLatestBcstMsgList()
            this.isShowAlarm = true
            if (res.data.count > 99) {
              this.count = '99+'
            } else {
              this.count = res.data.count
            }
          } else {
            this.count = 0
          }
        }
      }).catch(() => {})
    },
    getFindLatestBcstMsgList() {
      const data = {
        startTime: '',
        endTime: ''
      }
      findLatestBcstMsgList(data).then((res) => {
        if (res.code === 200) {
          // res.data.webBcstMsgList.map((item) => {
          //   if (item.bizCode === 'batteryHigh') {
          //     this.alarmList.push(JSON.parse(item.content))
          //   }
          // })
          this.alarmList = res.data.batteryWarnList
          this.alarmList = this.alarmList.filter((item, index, self) => {
            const firstIndex = self.findIndex((obj) => obj.ebikeId === item.ebikeId)
            return index === firstIndex
          })
          // this.alarmList.map((item) => {
          //   item.lat = '31.668073'
          //   item.lng = '119.055633'
          // })
        }
      }).catch(() => {})
    },
    handleAlarmClose() {
      this.alarmDialogVisible = false
    },
    showAlarm() {
      // if (this.count > 0) {
      this.alarmDialogVisible = true
      // }
    },
    handlerFold() {
      this.isHome = !this.isHome
    },
    handleClose() {
      this.passwordDialogVisible = false
      this.changePwForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassWord: ''
      }
    },
    cancelReadOnly() {
      this.readonlyInput = false
    },
    showChangePw() {
      this.passwordDialogVisible = true
    },
    sumbitPw() {
      this.$refs.changePwFormRef.validate((valid) => {
        if (valid) {
          innerUpdatePwd(this.changePwForm)
            .then((res) => {
              if (res.code === 200) {
                this.logout()
              }
            })
            .catch(() => {})
        } else {
          return false
        }
      })
    },
    changeTab() {
      if (this.activeTab === 'one') {
        this.dialogVisible = false
      } else {
        this.dialogVisible = true
      }
    },
    changeLanguage() {
      if (this.lang === 'zh') {
        this.lang = 'en'
      } else {
        this.lang = 'zh'
      }
      this.$i18n.locale = this.lang
      localStorage.setItem('lang', this.lang)
      this.$bus.$emit('lang', this.lang)
      console.log('=====', this.lang)
      if (this.$route.path === '/systemNotification') {
        this.permName = this.lang === 'zh' ? this.$t('tabmenu.name33') : 'Notifications'
        localStorage.setItem('permName', this.permName)
      } else {
        this.menulist.map((item, index) => {
          if (index === this.clickIndex) {
            if (this.lang === 'zh') {
              this.permName = item.menuName
            } else {
              this.permName = item.emenuName
            }
            localStorage.setItem('permName', this.permName)
            this.permUrl = this.$route.path
          }
        })
      }
    },
    getMenusList() {
      getMenus()
        .then(res => {
          if (res.code === 200) {
            this.menulist = res.data.menus
            console.log('this.menulist===', this.menulist)
            this.menulist.map((item, index) => {
              console.log('item.component===', item.component)
              if (item.component === 'systemNotification') {
                this.isShowNotice = true
                if (this.lang === 'zh') {
                  this.noticePermName = item.menuName
                } else {
                  this.noticePermName = item.emenuName
                }
                this.menulist.splice(index, 1)
              }
            })
            const buttonPermsList = []
            res.data.button.map(item => {
              buttonPermsList.push(item.perms)
            })
            this.buttonPerms = buttonPermsList.join(',')
            localStorage.setItem('buttonPerms', this.buttonPerms)
            // console.log('path===', this.$route.path)
            this.setActive()
          }
        })
        .catch(() => {})
    },
    setActive() {
      this.permName = localStorage.getItem('permName')
      this.permUrl = this.$route.path
      this.clickIndex = Number(localStorage.getItem('clickIndex')) || 0
      let permName1 = ''
      let permName2 = ''
      console.log('menulist==', this.menulist)
      this.menulist.map((item, indexs) => {
        if (this.permUrl === '/' + item.component) {
          if (this.lang === 'zh') {
            this.permName = item.menuName
          } else {
            this.permName = item.emenuName
          }
          permName1 = item.menuName
          permName2 = item.emenuName
        }
        item.childList.map((items) => {
          const isSmsConfigPage = this.permUrl === '/smsConfiguration'
          if (this.permUrl === '/' + items.component || (isSmsConfigPage && items.component === 'manufacturerslist')) {
            if (this.lang === 'zh') {
              this.permName = item.menuName
            } else {
              this.permName = item.emenuName
            }
            permName1 = items.menuName
            permName2 = items.emenuName
            this.clickIndex = indexs
          }
          items.childList.map((itemss) => {
            if (this.permUrl === '/' + itemss.component || (isSmsConfigPage && itemss.component === 'manufacturerslist')) {
              if (this.lang === 'zh') {
                this.permName = item.menuName
              } else {
                this.permName = item.emenuName
              }
              permName1 = itemss.menuName
              permName2 = itemss.emenuName
              this.clickIndex = indexs
            }
          })
        })
      })
      // console.log('this.permName===', this.permName)
      if (this.permUrl === '/systemNotification') {
        this.isHome = true
        if (this.lang === 'zh') {
          this.permName = this.$t('tabmenu.name33')
        } else {
          this.permName = 'Notifications'
        }
        this.tagList.push({ name: this.$t('tabmenu.name33'), ename: 'Notifications', path: '/systemNotification', index: this.clickIndex })
      } else if (this.permUrl === '/setting') {
        this.isHome = true
        if (this.lang === 'zh') {
          this.permName = this.$t('tabmenu.name34')
        } else {
          this.permName = 'Setting'
        }
        this.tagList.push({ name: this.$t('tabmenu.name34'), ename: 'Setting', path: '/setting', index: this.clickIndex })
      } else if (this.permUrl === '/smsConfiguration') {
        this.isHome = false
        // permName 需为一级菜单名（如「管理」），才能显示二级侧边栏
        if (!this.permName || this.permName === this.$t('bike.name533') || this.permName === 'SMSConfiguration') {
          this.menulist.map((item, index) => {
            if (index === this.clickIndex) {
              if (this.lang === 'zh') {
                this.permName = item.menuName
              } else {
                this.permName = item.emenuName
              }
            }
          })
        }
        localStorage.setItem('permName', this.permName)
        localStorage.setItem('clickIndex', this.clickIndex)
        this.tagList.push({ name: this.$t('bike.name533'), ename: 'SMSConfiguration', path: '/smsConfiguration', index: this.clickIndex })
      } else {
        this.tagList.push({ name: permName1, ename: permName2, path: this.permUrl, index: this.clickIndex })
      }
    },
    logout() {
      this.$store
        .dispatch('user/logout')
        .then(() => {
          Cookies.remove('vue_admin_token')
          localStorage.setItem('buttonPerms', '')
          localStorage.setItem('permName', '')
          localStorage.setItem('clickIndex', 0)
          this.$router.replace('/login')
        })
        .catch(() => {})
    },
    sidebarMenuText(menuItem) {
      if (!menuItem) return ''
      if (this.lang === 'zh') return menuItem.menuName
      // 有子菜单的分组项用后端 emenuName，避免与子页共用 component 时映射到叶子页文案
      if (menuItem.childList && menuItem.childList.length > 0) {
        return menuItem.emenuName
      }
      const key = getTabmenuKeyByComponent(menuItem.component)
      if (key) return this.$t(key)
      return menuItem.emenuName
    },
    sidebarMenuTooltip(menuItem) {
      if (!menuItem || this.lang === 'zh') return ''
      return menuItem.emenuName || this.sidebarMenuText(menuItem)
    },
    clickTab(item, index) {
      // console.log('item===', item)
      if (item) {
        if (this.lang === 'zh') {
          this.permName = item.menuName
        } else {
          this.permName = item.emenuName
        }
        localStorage.setItem('permName', this.permName)
        // console.log('===', item)
        if (item.menuId === 2019) {
          this.permUrl = '/' + item.childList[0].component
          this.$router.push('/' + item.childList[0].component)
        } else {
          this.permUrl = '/' + item.childList[0].childList[0].component
          this.$router.push('/' + item.childList[0].childList[0].component)
        }
      }
      this.clickIndex = index
      localStorage.setItem('clickIndex', this.clickIndex)
      console.log('this.clickIndex====22', this.clickIndex)
    },
    goSetting() {
      this.settingPermName = this.$t('tabmenu.name34')
      this.menulist.map((item, index) => {
        if (item.component === 'home') {
          if (this.lang === 'zh') {
            this.permName = item.menuName
          } else {
            this.permName = item.emenuName
          }
        }
      })
      localStorage.setItem('permName', this.permName)
      this.permUrl = '/'
      this.isHome = true
      this.$router.push('/setting')
    },
    goSystemNotification() {
      this.menulist.map((item, index) => {
        if (item.component === 'home') {
          if (this.lang === 'zh') {
            this.permName = item.menuName
          } else {
            this.permName = item.emenuName
          }
        }
      })

      localStorage.setItem('permName', this.permName)
      this.permUrl = '/'
      this.isHome = true
      this.$router.push('/systemNotification')
    },
    handleCloseTag(tag) {
      if (tag.type === '') {
        this.$router.go(-1)
      }
      this.tagList.map((item, index) => {
        if (item.path === tag.path) {
          this.tagList.splice(index, 1)
        }
      })
    },
    handleClickTag(tag) {
      // this.$router.push(tag.path)
      // console.log('tag===', tag)
      // this.permUrl = tag.path
      this.clickIndex = tag.index
      if (this.clickIndex === 5 || this.clickIndex === 6) {
        if (this.lang === 'zh') {
          this.permName = tag.name
        } else {
          this.permName = tag.ename
        }
        localStorage.setItem('permName', this.permName)
        this.permUrl = tag.path
        this.$router.push(tag.path)
      }
      this.menulist.map((item, index) => {
        if (index === tag.index) {
          if (this.lang === 'zh') {
            this.permName = item.menuName
          } else {
            this.permName = item.emenuName
          }
          localStorage.setItem('permName', this.permName)
          this.permUrl = tag.path
          // console.log('===3', this.permUrl)
          // console.log('===4', this.permName)
          this.$router.push(tag.path)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-button--mini.is-circle {
  padding:4px !important;
  position: fixed;
  right: 45px;
  top: 55px;
  z-index: 1000;
}
.alarm-dialog{
  .el-dialog{
    margin-top: 5vh !important;
  }
}
.change-pw-dialog {
  .el-form-item__label {
    box-sizing: border-box;
    padding-left: 10px;
    white-space: nowrap;
  }
}
.el-tag{
  cursor: pointer;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.el-dialog__body {
  border-top: 0px solid #dddddd !important;
}

.custom-sy {
  width: 24px;
  height: 24px;
  background-image: url(../assets/sy-icon.png);
  background-size: cover;
  display: inline-block;
}

.custom-cl {
  width: 24px;
  height: 24px;
  background-image: url(~@/assets/cl-icon.png);
  background-size: cover;
  display: inline-block;
}

.custom-gl {
  width: 24px;
  height: 24px;
  background-image: url(~@/assets/gl-icon.png);
  background-size: cover;
  display: inline-block;
}

.custom-yy {
  width: 24px;
  height: 24px;
  background-image: url(~@/assets/yy-icon.png);
  background-size: cover;
  display: inline-block;
}

.custom-cw {
  width: 24px;
  height: 24px;
  background-image: url(~@/assets/cw-icon.png);
  background-size: cover;
  display: inline-block;
}
</style>
<style lang="scss" scoped>
.left-container{
  height: 100%;
  overflow: auto;
  .alarm-containers{
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  right: 55px;
  top: 48px;
  z-index: 999;
  .right-alarm-list{
    width: 300px;
    height: 49px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    background: #fff;
    overflow: hidden;
    box-shadow: 0px 4px 10px 0px #00000040;
    .el-icon-arrow-up{
      font-size: 12px;
      margin-right: 15px;
      margin-top: 5px;
      cursor: pointer;
      z-index: 1000;
    }
      .item-contents{
        width: 300px;
        font-size: 14px;
        line-height: 22px;
        color: #555555;
        .item-ebike{
          width: 100%;
          padding-left: 15px;
          .item-ebike-id{
            font-weight: 600;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .item-ebike-text{
            color: #e4393c;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
    }
  }
  .red-dot{
    position: fixed;
  // left: 45px;
  margin-left: 45px;
  top: 55px;
  z-index: 1000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  background: #df4848;
  }
  .alarm-icon{
    width: 80px;
    height: 80px;
  }
  .alarm-icon1{
    width: 80px;
    height: 80px;
    cursor: pointer;
  }
  }
  .fold-containers{
    position: fixed;
    left: calc(var(--nav-rail-width) + 3.5px);
    top: 50%;
    z-index: 999;
    .el-icon-arrow-right{
      font-size: 28px;
      font-weight: 800;
      color: #0f73e6;
      cursor: pointer;
    }
  }
  .fold-container{
    position: fixed;
    left: calc(var(--nav-sidebar-expanded-width) + 9.5px);
    top: 50%;
    z-index: 999;
    .el-icon-arrow-left{
      font-size: 28px;
      font-weight: 800;
      color: #0f73e6;
      cursor: pointer;
    }
  }
}
.top-layout {
  display: flex;
  position: fixed;
  top: 0;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 48px;
  box-shadow: 0px 4px 10px 0px #00000040;
  background: #f1f1f1;
  z-index: 998;
}
.top-icon {
  margin-left: 20px;
  height: 48px;
}

.title {
  color: #555555;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  margin-left: 24px;
  margin-right: 30px;
}
.ico-navbar {
  width: 24px;
  height: 24px;
}
.zhxx{
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    width: 400px;
    border-bottom: 1px solid #f1f1f1;
    height: 35px;
    .tcdl{
      display: flex;
      flex-direction: row;
      color: #0f73e6;
      cursor: pointer;
    }
    .margin-right20{
      margin-right: 20px;
    }
  }
  .item-style{
      margin-top: 10px;
      font-size: 16px;
      :last-child{
        font-weight: 600;
      }
    }
.left-bottom-layout {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  width: var(--nav-rail-width, 80px);
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .user-head {
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .icon-language{
    margin-top: 20px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .el-icon-setting {
    font-size: 24px;
    margin-top: 20px;
    cursor: pointer;
  }
  .bell {
    position: relative;
    cursor: pointer;
    .el-icon-bell {
      font-size: 24px;
    }
    div {
      position: absolute;
      right: -5px;
      top: -2px;
      background: #df4848;
      padding: 0px 3px;
      font-size: 10px;
      color: #fff;
    }
  }
}
</style>
